import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Routes from "./views/routes";
import * as serviceWorker from "./serviceWorker";
import intl from "react-intl-universal";
import ar from "i18n/ar.js";
import fr from "i18n/fr.js";
import en from "i18n/en.js";

let langUse: string='en';
// JsBridge.callMethod("getAppInfo",123,{},
//   function (msg: any) {
//     if (msg.code === "0" || msg.code === 0) {
//       if (msg.data.mcc) {
//         langUse='ar';
//         document.body.style.direction = "rtl";
//       }
//     }
//   },function(){
//     langUse='en';
//   }
// )

intl.init({
  currentLocale: langUse,
  locales: {
    ar,
    fr,
    en,
  }
});

ReactDOM.render(<Routes />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
